import React, { Component, Fragment } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  margin-bottom: 20px;
`

const assetsBaseUrl = 'https://volby2022.netlify.app'

class Elections extends Component {
  shouldComponentUpdate () {
    return false
  }

  componentDidMount () {
    const widget = document.createElement('script')
    widget.src = `${assetsBaseUrl}/volby/assets/widget.js`
    widget.setAttribute('type', 'module')
    widget.setAttribute('crossorigin', 'anonymous')
    document.body.appendChild(widget)
  }

  render () {
    return (
      <Fragment>
        <script id="data-widget-volby-2022" type="application/json" dangerouslySetInnerHTML={{
          __html: `{
            "brand": "HPX",
            "mobileBreakPoint": 729,
            "linkToInfographics":"https://zpravy.aktualne.cz/domaci/komunalni-volby-2022-infografika/r~a296be00277411eda5920242ac11000b/",
            "linkToSenateInfographics":"https://zpravy.aktualne.cz/domaci/vysledky-senatni-volby-2022/r~0801a73438c611ed8c6f0cc47ab5f122/"
          }`
        }}/>
        <Wrapper id="root-widget-volby-2022"/>
      </Fragment>
    )
  }
}

export default Elections
